import { render, staticRenderFns } from "./NavMenuItem.vue?vue&type=template&id=2923af39"
import script from "./NavMenuItem.vue?vue&type=script&lang=ts"
export * from "./NavMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./NavMenuItem.vue?vue&type=style&index=0&id=2923af39&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports